import {localize} from '@vee-validate/i18n';

const localization = {};

const initValidationLocalization = (opts) => {
    localization[opts.locale] = {
        names: opts.translations,
        messages: opts.messageTranslations,
    };
};

const localizedValidationMessages = () => localize(localization);

export default localizedValidationMessages;
export {
    initValidationLocalization,
};
